import { core, rest, ng1 } from '@updater/redux-http-request';
import { HTTP_STATUS_CODES } from '../../constants';

const coreMatchers = core.matchers;
const restMatchers = rest.matchers;
const ng1Matchers = ng1.matchers;

export { coreMatchers as core, restMatchers as rest, ng1Matchers as ng1 };

export const isRequestResponseStatus = {
  unauthorized: ng1Matchers.isResponseStatus(HTTP_STATUS_CODES.UNAUTHORIZED),
  forbidden: ng1Matchers.isResponseStatus(HTTP_STATUS_CODES.FORBIDDEN),
  redirect: ng1Matchers.isResponseStatus(HTTP_STATUS_CODES.REDIRECT),
};
